"use client";

import { useQuery } from "@tanstack/react-query";
import type { AimOfAnalysis } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { getTopics } from "../api/getTopics";
import { backlogKeys } from "./keys";

type UseTopicsForOriginQueryParams = {
  aim?: AimOfAnalysis | null;
  enabled?: boolean;
  onlyConfirmed?: boolean;
  originId: string;
};

export default function useTopicsForOriginQuery({
  aim,
  enabled = true,
  onlyConfirmed = true,
  originId,
}: UseTopicsForOriginQueryParams) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: backlogKeys.topicsForOrigin({ aim, onlyConfirmed, originId }),
    queryFn: () =>
      getTopics(accessToken, {
        aim: aim ?? undefined,
        only_confirmed: onlyConfirmed,
        origin_id: originId,
      }),
    enabled: enabled && Boolean(originId),
  });
}
